import { makeAction } from '@va/store';

export const GENERATE_IMPERSONATE_TOKEN = 'GENERATE_IMPERSONATE_TOKEN';
export const GENERATE_IMPERSONATE_TOKEN_SUCCEEDED = 'GENERATE_IMPERSONATE_TOKEN_SUCCEEDED';
export const GENERATE_IMPERSONATE_TOKEN_FAILED = 'GENERATE_IMPERSONATE_TOKEN_FAILED';

export const generateImpersonateToken = makeAction(GENERATE_IMPERSONATE_TOKEN, 'data');
export const generateImpersonateTokenSucceeded = makeAction(GENERATE_IMPERSONATE_TOKEN_SUCCEEDED, 'data');
export const generateImpersonateTokenFailed = makeAction(GENERATE_IMPERSONATE_TOKEN_FAILED, 'error');
